module.exports = __webpack_public_path__ + "img/FB.9de11ded.png";